import moment from 'moment';
import { getMacFromLocalStorage } from '../../../../api/auth';
import { getDeviceDisplayName } from '../../../../config';
import { HttpClientError } from '../../../../controllers/http-client/http-client';
import { ScriptService } from '../../../../controllers/ScriptService';
import { getAuth } from '../../../../utils/auth-utils';
import { queryClient } from '../../../client';
import { AtsHttpClient } from '../../ats-http-client';
import { settings } from '../../settings';
import { HttpPlaybackError } from '../error';
import { devicesQuery } from './queries';
import { Device } from './types';

const http = new AtsHttpClient();

export async function registerDevice(): Promise<Device> {
  const { auth } = getAuth();

  if (!auth) {
    throw new Error('Unauthorized');
  }

  try {
    const res = await http.put<Promise<Device>>(
      `/playback/subscribers/${auth.userID}/devices/${getMacFromLocalStorage()}`,
      {
        devicePlatform: 'app-web-general',
        deviceClass: ScriptService._isSafari() ? 'apple' : 'web',
        deviceName: `${getDeviceDisplayName()} ${moment().format('L')}`,
      },
      settings.playback('1.0'),
    );
    queryClient.invalidateQueries(devicesQuery());

    return res;
  } catch (error) {
    if (error instanceof HttpClientError) {
      throw new HttpPlaybackError(error);
    }

    throw error;
  }
}

export async function getDevices() {
  const { auth } = getAuth();

  if (!auth) {
    throw new Error('Unauthorized');
  }

  const devices = await http.get<Device[]>(`/playback/subscribers/${auth.userID}/devices`, settings.playback('1.0'));
  return devices;
}

export async function removeDevice(deviceId: string) {
  const { auth } = getAuth();

  if (!auth) {
    throw new Error('Unauthorized');
  }

  try {
    await http.delete(`/playback/subscribers/${auth.userID}/devices/${deviceId}`, {}, settings.playback('1.0'));
    queryClient.invalidateQueries(devicesQuery());
  } catch (error) {
    console.error(error);
  }
}
